<template>
  <div>
    <CustomCard
      header="Billing Period"
      subHeader="List of all billing period.">
      <template v-slot:body>
        <Full
          @create="setCreate()"
          :noCreateButton="!isAccessible($options.BillingPeriodPermissions.ADD.id)"
          placeholder="Search Billing Period"
          buttonLabel="Create Billing Period"
          :filter="filters.billingPeriod"
          :table="tables.billingPeriods"
          :pagination="paginations.billingPeriod">
          <template v-slot:cell(isActive)="{ value }">
            <b-badge :variant="value ? 'success' : 'danger'">{{ value ? 'ACTIVE' : 'INACTIVE' }}</b-badge>
          </template>
          <template v-slot:cell(action)="data">
            <b-dropdown 
              v-if="isAccessible([$options.BillingPeriodPermissions.EDIT.id])"
              boundary="window" 
              right
              variant="link" 
              toggle-class="text-decoration-none"
              no-caret>
              <template v-slot:button-content>
                <v-icon name="ellipsis-v" />
              </template>
              <b-dropdown-item
                v-if="isAccessible($options.BillingPeriodPermissions.EDIT.id)"
                @click="setUpdate(data)"
                :disabled="showModalEntry">
                Edit
              </b-dropdown-item>
               <b-dropdown-item
                v-if="isAccessible($options.BillingPeriodPermissions.EDIT.id)"
                @click="setActive(data.item)"
                :disabled="showConfirmActive">
                Set as Active
              </b-dropdown-item>
              <!-- <b-dropdown-item
                v-if="isAccessible($options.BillingPeriodPermissions.DELETE.id)"
                @click="setDelete(data.item.id)"
                :disabled="showModalConfirmation">
                Delete
              </b-dropdown-item> -->
            </b-dropdown>
          </template>
        </Full>
      </template>
    </CustomCard>
    <BillingPeriodEntry
      @save="onBillingPeriodEntry()"
      @close="showModalEntry = false"
      :show="showModalEntry"
      :form="forms.billingPeriod"
      :mode="entryMode" />
    <DeleteConfirmation
      @close="showModalConfirmation = false"
      @yes="onBillingPeriodDelete()"
      :show="showModalConfirmation"
      :isProcessing="forms.billingPeriod.isProcessing"
      name="Billing Period" />
    
    <Confirmation
      :show="showConfirmActive"
      @yes="onActivate"
      @close="showConfirmActive = false"
      :isProcessing="isActivating">
      Are you sure you want to set this billing period as active ?
    </Confirmation>
  </div>
</template>
<script>
const billingPeriodFields = {
  id: null,
  monthId: null,
  year: null
}
import { CustomCard, DeleteConfirmation } from './../../components'
import Full from '../../components/Full'
import BillingPeriodEntry from './BillingPeriodEntry'
import { clearFields, reset, showNotification, validate } from '../../../helpers/forms' 
import { BillingPeriodApi } from '../../../mixins/api'
import tables from '../../../helpers/tables'
import { copyValue } from '../../../helpers/extractor'
import { BillingPeriodPermissions } from '../../../helpers/enum'
import Access from '../../../mixins/utils/Access'
import Confirmation from '../../components/Confirmation.vue'
export default {
  components: {
    Full,
    CustomCard,
    BillingPeriodEntry,
    DeleteConfirmation,
    Confirmation
},
  mixins: [ BillingPeriodApi, tables, Access ],
  BillingPeriodPermissions,
  data() {
    return {
      entryMode: 'Add',
      showModalEntry: false,
      showModalConfirmation: false,
      showConfirmActive: false,
      isActivating: false,
      forms: {
        billingPeriod: {
          isProcessing: false,
          fields: { ...billingPeriodFields },
          states: { ...billingPeriodFields },
          errors: { ...billingPeriodFields },
        }
      },
      tables: {
        billingPeriods: {
          isBusy: false,
          fields: [
            {
              key: 'month.name',
              label: 'Month/Year',
              tdClass: 'align-middle',
              thStyle: 'width: auto',
              sortable: true,
              formatter: (value, key, item) => {
                return value + ' ' + item.year
              }
            },
            {
              key: 'isActive',
              label: 'Status',
              tdClass: 'align-middle text-center',
              thClass: 'text-center',
              thStyle: 'width: 100px',
              sortable: true
            },
            {   
              key: 'action',
              label: '',
              thStyle: {width: '85px'},
              tdClass: 'text-center align-middle'
            },
          ],
          items: []
        }
      },
      paginations: {
        billingPeriod: {
          from: 0,
          to: 0,
          totalRows: 0,
          page: 1,
          perPage: 10,
        }
      },
      filters: {
        billingPeriod: {
          criteria: null
        }
      },
      selectedPeriod: null
    }
  },
  created() {
    this.loadBillingPeriod()
  },
  methods: {
    loadBillingPeriod() {
      const params = {
        paginate: false
      }
      const { billingPeriods } = this.tables
      const { billingPeriod } = this.paginations
      billingPeriods.isBusy = true
      this.getBillingPeriodList(params)
      .then(({ data }) => {
        billingPeriods.items = data
        billingPeriod.totalRows = data.length
        this.recordDetails(billingPeriod)
        billingPeriods.isBusy = false
      })
    },
    onBillingPeriodEntry(){
      const { billingPeriod, billingPeriod: { fields } } = this.forms
      const { billingPeriods } = this.tables
      billingPeriod.isProcessing = true
      reset(billingPeriod)
      const data = {...fields}
      if(this.entryMode == "Add"){
        this.addBillingPeriod(data)
          .then(({ data }) => {
            this.loadBillingPeriod()
            billingPeriod.isProcessing = false
            showNotification(this, "success", "Billing Period created successfully.")
            this.showModalEntry = false
          })
          .catch(error => {
            const errors = error.response.data.errors
            billingPeriod.isProcessing = false
            validate(billingPeriod, errors)
          })
      }
      else {
        const { fields } = this.forms.billingPeriod
        this.updateBillingPeriod(data, fields.id)
          .then(({ data }) => {
            this.loadBillingPeriod()
            billingPeriod.isProcessing = false
            showNotification(this, "success", "Billing Period updated successfully.")
            this.showModalEntry = false
          })
          .catch(error => {
            const errors = error.response.data.errors
            billingPeriod.isProcessing = false
            validate(billingPeriod, errors)
          })
      }
    },
    onBillingPeriodDelete(){
      const { billingPeriod, billingPeriod: { fields: { id } } } = this.forms
      const { billingPeriods } = this.tables
      billingPeriod.isProcessing = true
      this.deleteBillingPeriod(id)
        .then(({ data }) => {
          this.deleteRow(billingPeriods, this.paginations.billingPeriod, id)
          billingPeriod.isProcessing = false
          showNotification(this, "success", "Billing Period deleted successfully.")
          this.showModalConfirmation = false
        })
        .catch(error => {
          const errors = error.response.data.errors
          billingPeriod.isProcessing = false
          if(errors.msg) {
            showNotification(this, "danger", errors.msg)
          }
        })
    },
    setUpdate(row){
      this.showModalEntry = true
      const { billingPeriod, billingPeriod: { fields } } = this.forms
      billingPeriod.isLoading = true
      copyValue(row.item, fields)
      reset(billingPeriod)
      this.entryMode = "Edit"
      billingPeriod.isLoading = false
    },
    setCreate() {
      const { billingPeriod, billingPeriod: { fields } } = this.forms
      clearFields(billingPeriod)
      fields.monthId = null
      fields.year = null
      reset(billingPeriod)
      this.entryMode = "Add"
      this.showModalEntry = true
    },
    setDelete(id) {
      const { fields } = this.forms.billingPeriod
      fields.id = id
      this.showModalConfirmation = true
    },
    setActive(row) {
      this.showConfirmActive = true
      this.selectedPeriod = row
    },
    onActivate() {
      this.isActivating = true
      const { id: billingPeriodId } = this.selectedPeriod
      this.activateBillingPeriod(billingPeriodId).then(({ data }) => {
        this.isActivating = false
        this.loadBillingPeriod()
        this.showConfirmActive = false
      }).catch(error => {
        const errors = error.response.data.errors
        this.isActivating = false
        showNotification(this, 'warning', 'Unable to activate period. Please contact your administrator.')
      })
    }
  }
}
</script>